import React from "react"
import modStyl from './index.module.scss'
import LazyIcon from "../../../components/lazy-icon"

type Props = {

}

const Finder = ()=> {
  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.west}>
        <LazyIcon name="zoom"/>
        <input placeholder="输入患者姓名进行搜索"/>
      </div>
      <div className={modStyl.east}>
        <ul>
          <li>
            <span>全部</span>
            <LazyIcon name="arrow-down"/>
          </li>
          <li>进行中</li>
          <li>未入组</li>
          <li>已完成</li>
        </ul>
      </div>
    </div>
  )
}

export default Finder